/**
 * Font Size
 *
 * - Desktop
 * - Mobile
 */

/* Desktop scale */
const CXD_DESKTOP_FONT_SIZE_50 = '11px'
const CXD_DESKTOP_FONT_SIZE_75 = '12px'
const CXD_DESKTOP_FONT_SIZE_100 = '14px' // Base size
const CXD_DESKTOP_FONT_SIZE_200 = '16px'
const CXD_DESKTOP_FONT_SIZE_300 = '18px'
const CXD_DESKTOP_FONT_SIZE_400 = '20px'
const CXD_DESKTOP_FONT_SIZE_500 = '22px'
const CXD_DESKTOP_FONT_SIZE_600 = '25px'
const CXD_DESKTOP_FONT_SIZE_700 = '28px'
const CXD_DESKTOP_FONT_SIZE_800 = '32px'
const CXD_DESKTOP_FONT_SIZE_900 = '36px'
const CXD_DESKTOP_FONT_SIZE_1000 = '40px'
const CXD_DESKTOP_FONT_SIZE_1100 = '45px'
const CXD_DESKTOP_FONT_SIZE_1200 = '50px'
const CXD_DESKTOP_FONT_SIZE_1300 = '60px'

/* Mobile scale */
const CXD_MOBILE_FONT_SIZE_50 = '13px'
const CXD_MOBILE_FONT_SIZE_75 = '15px'
const CXD_MOBILE_FONT_SIZE_100 = '17px' // Base size
const CXD_MOBILE_FONT_SIZE_200 = '19px'
const CXD_MOBILE_FONT_SIZE_300 = '22px'
const CXD_MOBILE_FONT_SIZE_400 = '24px'
const CXD_MOBILE_FONT_SIZE_500 = '27px'
const CXD_MOBILE_FONT_SIZE_600 = '31px'
const CXD_MOBILE_FONT_SIZE_700 = '34px'
const CXD_MOBILE_FONT_SIZE_800 = '39px'
const CXD_MOBILE_FONT_SIZE_900 = '44px'
const CXD_MOBILE_FONT_SIZE_1000 = '49px'
const CXD_MOBILE_FONT_SIZE_1100 = '55px'
const CXD_MOBILE_FONT_SIZE_1200 = '62px'
const CXD_MOBILE_FONT_SIZE_1300 = '70px'

export {
  CXD_DESKTOP_FONT_SIZE_50,
  CXD_DESKTOP_FONT_SIZE_75,
  CXD_DESKTOP_FONT_SIZE_100,
  CXD_DESKTOP_FONT_SIZE_200,
  CXD_DESKTOP_FONT_SIZE_300,
  CXD_DESKTOP_FONT_SIZE_400,
  CXD_DESKTOP_FONT_SIZE_500,
  CXD_DESKTOP_FONT_SIZE_600,
  CXD_DESKTOP_FONT_SIZE_700,
  CXD_DESKTOP_FONT_SIZE_800,
  CXD_DESKTOP_FONT_SIZE_900,
  CXD_DESKTOP_FONT_SIZE_1000,
  CXD_DESKTOP_FONT_SIZE_1100,
  CXD_DESKTOP_FONT_SIZE_1200,
  CXD_DESKTOP_FONT_SIZE_1300,
  CXD_MOBILE_FONT_SIZE_50,
  CXD_MOBILE_FONT_SIZE_75,
  CXD_MOBILE_FONT_SIZE_100,
  CXD_MOBILE_FONT_SIZE_200,
  CXD_MOBILE_FONT_SIZE_300,
  CXD_MOBILE_FONT_SIZE_400,
  CXD_MOBILE_FONT_SIZE_500,
  CXD_MOBILE_FONT_SIZE_600,
  CXD_MOBILE_FONT_SIZE_700,
  CXD_MOBILE_FONT_SIZE_800,
  CXD_MOBILE_FONT_SIZE_900,
  CXD_MOBILE_FONT_SIZE_1000,
  CXD_MOBILE_FONT_SIZE_1100,
  CXD_MOBILE_FONT_SIZE_1200,
  CXD_MOBILE_FONT_SIZE_1300,
}
